module.exports = __webpack_public_path__ + "img/Alignments & Mode_01.11b2f668.jpg";